import React, { useCallback, useState } from 'react';
import { appleAuthHelpers } from 'react-apple-signin-auth';
import { useDispatch } from 'react-redux';
import CONFIG from '../../../../configs/config';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import ActionButton from '../../../elements/ActionButton/ActionButton';
import AppleIcon from './apple-brands-solid-full.svg';
import styles from './AppleLoginButton.module.scss';
import { useAppleSDK } from './useAppleSDK';
import AskForName from './AskForName';

function AppleLoginButton(props) {
    const { className = '', children } = props,
        i18n = useI18n(),
        dispatch = useDispatch(),
        sdkLoaded = useAppleSDK(),
        [loginData, setLoginData] = useState(),
        [askForName, setAskForName] = useState(false);

    const handleClick = useCallback(async () => {
        dispatch(app.actions.ui.busy());

        try {
            const { authorization, user } = await new Promise((resolve, reject) =>
                appleAuthHelpers.signIn({
                    authOptions: {
                        clientId: CONFIG.appleClientId, // Service ID
                        redirectURI: CONFIG.appleRedirectURI, // must match Apple config
                        scope: 'name email',
                        state: '',
                        nonce: 'nonce',
                        usePopup: true,
                    },
                    onSuccess: (response, ...others) => resolve(response),
                    onError: (error) => reject(error),
                })
            );

            setLoginData([authorization, user]);
            const { is_new } = await app.api.session.appleLogin(authorization, user);
            if (is_new) {
                app.history.push('/new_account');
            }
        } catch (error) {
            if (error?.response?.data?.error == 'validation failed') {
                setAskForName(true);
            } else {
                console.error(error);
            }
        } finally {
            dispatch(app.actions.ui.free());
        }
    }, [dispatch]);

    if (!sdkLoaded) return null;

    return (
        <>
            <ActionButton className={[className, styles.AppleLoginButton].join(' ')} icon={<AppleIcon className="icon" />} onClick={handleClick} next>
                {children ?? i18n['label.signin.apple']}
            </ActionButton>
            {askForName ? <AskForName loginData={loginData} onClose={() => setAskForName(false)} /> : null}
        </>
    );
}

export default AppleLoginButton;
